import React from 'react'
import StockHistoryContainer from '../../containers/inventorymng/history/StockHistoryContainer'

const InventoryHistoryPage = () => {
  return (
    <StockHistoryContainer />
  )
}

export default InventoryHistoryPage